import EduContent from '@/Apis/EduContent'
import Model from '../Apis/Edu_courses'
import Edu_programs from '../Apis/Edu_programs'
import Controller from './Controller'

export default class EduCoursesController extends Controller {
  constructor() {
    super(new Model())
    this.eduContent = new EduContent();
  }

  async Home() {
    let data = {}
    let eduProgramId = localStorage.getItem("eduProgram")
    data = await new Edu_programs().Show(eduProgramId)
    // data.announcements= await new  Announcements().HomeAnnouncements();
    // data.polls= await new  Polls().HomePolls();
    return data
  }
   Types() {
    return this.eduContent.Types();
  }
  GetType(type) {
    return this.eduContent.GetType(type);
  }
  async getContentsNow(params) {
    const data = await this.model.getContentsNow(params)
    return data
  }

  async GetContents(params) {
    const data = await this.model.GetContents(params)
    return data
  }

  async EduCourseProgramsActiveSemester(params) {
    const data = await this.model.EduCourseProgramsActiveSemester(params)
    return data
  }
  async ContentComments(params) {
    const data = await this.model.ContentComments(params)
    return data
  }
  async GetAssessments(params) {
    const data = await this.model.getAssessments(params)
    return data
  }
  async EduCoursePrograms(params) {
    const data = await this.model.EduCoursePrograms(params)
    return data
  }
  //
  async teacherCourses(params){
    const res = await this.model.teacherCourses(params);
    return  res;
  }
  async GetAllCourses(){
    const res = await this.model.GetAllCourses();
    return  res;
  }
}
